import { OVERLAY_IDS } from "@constants/overlay-ids";
import OverlayPresenceStore from "@utils/OverlayPresenceStore";
import { KzOverlayEventDetail } from "kz-ui-sdk";

import { dispatchAnalyticsEvent } from "./dispatch";
import { EVENTS } from "./events/constants";
import { providersReady } from "./providers";

type QueuedEvent = { eventName: string; metadata: Record<string, unknown> };

let queue: QueuedEvent[] | null = [];
void providersReady.then(() => {
  queue?.forEach(({ eventName, metadata }) => dispatchAnalyticsEvent(eventName, metadata));
  queue = null;
});

function emit(eventName: string, metadata: Record<string, unknown>): void {
  if (queue) {
    queue.push({ eventName, metadata });
    return;
  }
  dispatchAnalyticsEvent(eventName, metadata);
}

// A caller-set overlayId is a stable name; a useId-shaped id (contains ":") falls
// back to the backdrop aria label.
function popupNameFrom(detail: KzOverlayEventDetail): string | null {
  if (!detail.overlayId.includes(":")) return detail.overlayId;
  return detail.label ?? null;
}

const popupMetadata = new Map<string, Record<string, unknown>>();

export function setPopupShownMetadata(overlayId: string, metadata: Record<string, unknown> | null): void {
  if (metadata) popupMetadata.set(overlayId, metadata);
  else popupMetadata.delete(overlayId);
}

// Pop-ups that send their own evt:popup_shown with more fields
const SELF_TRACKED_OVERLAY_IDS: ReadonlySet<string> = new Set([OVERLAY_IDS.COUNTDOWN_BOOST_POPUP]);

OverlayPresenceStore.getInstance().onOpened((detail) => {
  if (SELF_TRACKED_OVERLAY_IDS.has(detail.overlayId)) return;
  const popupName = popupNameFrom(detail);
  if (popupName) emit(EVENTS.POPUP_SHOWN, { popupName, ...popupMetadata.get(detail.overlayId) });
});
